import { render, staticRenderFns } from "./AddPolicyDialog.html?vue&type=template&id=6196c23e&external"
import script from "./AddPolicyDialog.js?vue&type=script&lang=js&external"
export * from "./AddPolicyDialog.js?vue&type=script&lang=js&external"
import style0 from "./AddPolicyDialog.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports